<template>
  <div @click="emit('updateOnboardingStep', { value: props.currentStep - 1 })" class="cursor-pointer hover:scale-105 duration-300 rounded-md bg-gray-800 px-3 py-2.5 text-text-primary flex justify-center items-center text-xl absolute top-8 left-4 lg:left-16">
    <img class="w-4 mr-1" src="../../assets/icons/leftarrow.svg">
    <h1 class="text-xs text-text-primary">{{ $t('common.back') }}</h1>
  </div>
  <div class="flex flex-col h-full items-center mt-16 lg:mt-0 lg:justify-center w-full lg:w-[640px]">
    <h1 class="text-text-primary text-[36px] font-bold pb-3">{{ $t('onboarding.play_now.title') }}</h1>
    <i18n-t scope="global" keypath="onboarding.play_now.subtitle" tag="h2" class="text-text-secondary text-center pb-6"><template #br><br /></template></i18n-t>

    <div class="lg:px-12 w-full flex items-center">
      <div class="border border-gray-800 rounded-md w-full p-6 flex flex-col items-center">
        <iframe
          src="https://www.youtube.com/embed/G_5OApGInys?si=pY3yKbqXJaIfGGot"
          loading="lazy"
          class="w-full aspect-[16/9]"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowfullscreen="true"
        />

        <h1 class="font-medium text-xl text-text-primary pt-4">{{ $t('onboarding.play_now.tutorial_title') }}</h1>
        <p class="font-light text-sm text-text-secondary pt-4 text-center px-8">{{ $t('onboarding.play_now.tutorial_description') }}</p>
      </div>

    </div>

    <div @click="emit('finishOnboarding')" class="cursor-pointer w-full py-3 text-text-primary bg-primary-600 hover:bg-primary-500 mt-10 rounded-md flex items-center justify-center gap-1">
      {{ $t('onboarding.play_now.complete') }}
      <img class="h-4 brightness-200" src="../../assets/icons/rightarrow.svg" :alt="$t('common.continue')" />
    </div>
  </div>
  <AlertPopup />
</template>

<script setup>
import AlertPopup from '../AlertPopup.vue';

const emit = defineEmits(['updateOnboardingStep', 'finishOnboarding']);

const props = defineProps({
  currentStep: Number,
});

</script>
